import React from 'react'

import {
  getImageAsset,
  useAnalyticsClient,
  useRemoteStrings,
} from '@acorns/web-utils'

import {
  trackEarnExtensionChromeExtensionCardEntryPointTappedPayload,
  trackEarnExtensionChromeExtensionCardEntryPointViewedPayload,
  trackEarnExtensionSafariExtensionCardEntryPointTappedPayload,
  trackEarnExtensionSafariExtensionCardEntryPointViewedPayload,
} from 'generated/trackingEvents'
import useAnalyticsComponentViewed from 'hooks/useAnalyticsComponentViewed'
import { useDisplayChromeExtensionCard } from 'hooks/useDisplayChromeExtensionCard'
import { useDisplaySafariExtensionCard } from 'hooks/useDisplaySafariExtensionCard'
import { EARN_EXTENSION_CARD } from 'utils/testing/testIDs'

import { EARN_EXTENSION_CARD_DEFAULT_CATEGORY } from './constants'
import {
  AnchorContainer,
  BackgroundImage,
  LearnMore,
  Subtitle,
  Title,
} from './styled-components'

export const EarnExtensionCard = () => {
  const { track } = useAnalyticsClient()
  const { getRemoteString } = useRemoteStrings()
  const { showChromeCard, loading: displayChromeLoading } =
    useDisplayChromeExtensionCard()
  const { showSafariCard, loading: displaySafariLoading } =
    useDisplaySafariExtensionCard()
  const isLoading = displayChromeLoading || displaySafariLoading

  const viewEventPayloadFunction = showChromeCard
    ? trackEarnExtensionChromeExtensionCardEntryPointViewedPayload
    : trackEarnExtensionSafariExtensionCardEntryPointViewedPayload

  const ref = useAnalyticsComponentViewed({
    generatedPayload: viewEventPayloadFunction({
      category: EARN_EXTENSION_CARD_DEFAULT_CATEGORY,
    }),
  })

  const handleClick = () => {
    const tapEventPayloadFunction = showChromeCard
      ? trackEarnExtensionChromeExtensionCardEntryPointTappedPayload
      : trackEarnExtensionSafariExtensionCardEntryPointTappedPayload

    track(
      ...tapEventPayloadFunction({
        category: EARN_EXTENSION_CARD_DEFAULT_CATEGORY,
      }),
    )
  }

  const hasOneCardShown = showChromeCard || showSafariCard
  if (isLoading || !hasOneCardShown) {
    return null
  }

  return (
    <AnchorContainer
      data-testid={EARN_EXTENSION_CARD}
      href={getRemoteString({
        key: showChromeCard
          ? 'earn.holiday.tour_tip.ext_url'
          : 'earn.holiday.tour_tip.ext_url.safari',
      })}
      onClick={handleClick}
      ref={ref}
      target="_blank"
    >
      <Title>
        {getRemoteString({
          key: showChromeCard
            ? 'earn.extension.download_pill.title'
            : 'earn.extension.download_pill.title.safari',
        })}
      </Title>
      <Subtitle>
        {getRemoteString({ key: 'earn.extension.download_pill.subtext' })}
      </Subtitle>
      <LearnMore>
        {getRemoteString({ key: 'earn.extension.download_pill.cta' })}
      </LearnMore>
      <BackgroundImage
        alt="Extension Card Decoration"
        src={
          getImageAsset(
            showChromeCard
              ? '/earn/holiday-2024/card-chrome'
              : '/earn/holiday-2024/card-safari',
            'png',
            '@4x',
          ).url
        }
      />
    </AnchorContainer>
  )
}
